import React from 'react';
import { CustomerInvoice } from '../invoicesPaymentTypes';
import { InvoiceStatusBadge } from './InvoiceStatusBadge';
import styles from './InvoicesTable.module.css';

interface InvoicesTableProps {
  invoices: CustomerInvoice[];
  onPayNow?: (invoiceId: string) => void;
  onDownload?: (invoiceId: string) => void;
}

export const InvoicesTable: React.FC<InvoicesTableProps> = ({
  invoices,
  onPayNow,
  onDownload,
}) => {
  if (invoices.length === 0) {
    return (
      <div className={styles.card}>
        <div className={styles.empty}>
          <p className={styles.emptyText}>No invoices found</p>
        </div>
      </div>
    );
  }

  const isPaid = (status: string) => status === 'paid';
  const isHighlightBalance = (status: string) =>
    status === 'Overdue' || status === 'Due Soon';

  return (
    <div className={styles.card}>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>INVOICE #</th>
              <th className={styles.th}>ORDER #</th>
              <th className={styles.th}>ISSUE DATE</th>
              <th className={styles.th}>DUE DATE</th>
              <th className={styles.th}>TOTAL AMOUNT</th>
              <th className={styles.th}>PAID AMOUNT</th>
              <th className={styles.th}>BALANCE</th>
              <th className={styles.th}>STATUS</th>
              <th className={styles.th}>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice) => (
              <tr key={invoice.id} className={styles.row}>
                <td className={styles.td}>
                  <span className={styles.invoiceNumber}>{invoice.invoiceNumber}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.orderNumber}>{invoice.orderNumber}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.date}>{invoice.issueDate}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.date}>{invoice.dueDate}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.amount}>{invoice.totalAmount}</span>
                </td>
                <td className={styles.td}>
                  <span className={styles.paidAmount}>{invoice.paidAmount}</span>
                </td>
                <td className={styles.td}>
                  <span
                    className={`${styles.balance} ${isHighlightBalance(invoice.status) ? styles.balanceRed : ''}`}
                  >
                    {invoice.balance}
                  </span>
                </td>
                <td className={styles.td}>
                  <InvoiceStatusBadge status={invoice.status} />
                </td>
                <td className={styles.td}>
                  {isPaid(invoice.status) ? (
                    <button
                      className={styles.downloadBtn}
                      onClick={() => onDownload?.(invoice.id)}
                    >
                      <svg viewBox="0 0 24 24" fill="currentColor" className={styles.btnIcon}>
                        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                      </svg>
                    </button>
                  ) : (
                    <button
                      className={styles.payNowBtn}
                      onClick={() => onPayNow?.(invoice.id)}
                    >
                      <svg viewBox="0 0 24 24" fill="currentColor" className={styles.btnIcon}>
                        <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                      </svg>
                      Pay Now
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
